import {
    ALLCANDIDATES,
    ALLINTERVIEW,
    JOBPOST,
    ALLQR,
    VIEWQRBYID
} from "./constant";
const initial_state = {
    all_candidates: [],
    all_candidateslength: 0,
    all_interviewslength: 0,
    all_interviews: [],
    all_jobpost: [],
    all_qrlength: 0,
    all_qr: [],
    qr_by_id: "",

};
export default function reducer(state = initial_state, action) {
    switch (action.type) {


        case ALLCANDIDATES:
            return state = { ...state, all_candidates: action.payload, all_candidateslength: action.count };


        case ALLINTERVIEW:
            return state = { ...state, all_interviews: action.payload, all_interviewslength: action.count };


        case JOBPOST:
            return state = { ...state, all_jobpost: action.payload, };

        case ALLQR:
            return state = { ...state, all_qr: action.payload, all_qrlength: action.count };

        case VIEWQRBYID:
            return state = { ...state, qr_by_id: action.payload, };

        default:
            return state;
    }
}
